/* eslint-disable no-underscore-dangle */
export default {
  computed: {
    ___heightHeaderSize: {
      cache: false,
      get() {
        const header = document.querySelector('header q-layout-header');
        if (header) {
          return header.getClientRects().height;
        }

        return 71;
      },
    },

    __cordovaFixQPageBind() {
      if (this.$q.platform.is.cordova && this.$q.platform.is.ios) {
        return {
          styleFn: (offset) => {
            const baseOffset = (offset <= 1) ? this.___heightHeaderSize : offset;
            const minHeight = `calc(100vh - ${baseOffset}px)`;

            return { minHeight };
          },
        };
      }

      return {};
    },

    __cordovaFixQPageContainerStyle() {
      if (this.$q.platform.is.cordova && this.$q.platform.is.ios) {
        return `padding-top: ${this.___heightHeaderSize}px;`;
      }

      return '';
    },
  },
};
